
<template>
  <div id="landing_redeem" class="column p0">
    <redeem-2fa
      v-if="!authorized"
      @getOptStatus="getOtpStatus"
      @switchMode="switchMode()"
    ></redeem-2fa>
    <DepositStepStart
      v-if="step == 'start' && authorized"
      @callFirstStep="callFirstStep"
      :buttonBlock="this.buttonBlock"
      :selectedBlue="selectedBlue"
    />
    <!-- {{ selectedBlue }} -->
    <DepositStep1
      v-if="step == 1"
      :selectedBlue="selectedBlue"
      :address="this.blueAddress"
    />
  </div>
</template>
<script>
import Redeem2fa from "./redeem_steps/Redeem2fa";
import DepositStepStart from "./deposit_steps/DepoistStepStart";
import DepositStep1 from "./deposit_steps/DepositStep1";
import { mapGetters } from "vuex";

import Swal from "sweetalert2";

export default {
  created() {
    this.getOtpStatus();
  },

  updated() {
    this.checkWallet();
  },
  props: ["selectedBlue"],
  mounted() {},
  data: () => ({
    withdraws: "",
    redeemInfo: "",
    step: "start",
    previewData: "",
    withdrawData: "",
    address: "",
    externalId: "",
    authorized: "",
    error: "",
    feeRedeem: "",
    preview: {
      targetAmount: "",
      sourceCurrency: "BLU",
    },
    type: "withdraw",
    withdraw: {
      amount: "",
      address: "",
      currency: "BLU",
      externalId: "",
    },
    selectedPartner: "",
    blueWallet: "",
    usdtWallet: "",
    blueAddress: "",
    buttonBlock: false,
  }),
  components: {
    Redeem2fa,
    DepositStepStart,
    DepositStep1,
  },
  methods: {
    checkWallet() {
      if (this.selectedBlue) {
        this.blueWallet = this.bluAccount;
        if (this.blueWallet.address.length > 0) {
          this.blueAddress = this.blueWallet.address;
          this.step = 1;
        } else {
          this.step = "start";
        }
      } else {
        console.log(this.usdtAccount, "aq??");
        this.usdtWallet = this.usdtAccount;
        if (this.usdtWallet.address) {
          this.blueAddress = this.usdtWallet.address;
          this.step = 1;
        } else {
          this.step = "start";
        }
      }
    },
    async callFirstStep() {
      if (this.selectedBlue) {
        let blueAccount = this.accounts.filter(function (n, i) {
          return n.currency.symbol === "BLU";
        });

        this.buttonBlock = true;
        if (blueAccount[0].address) {
          Swal.fire(
            {
              icon: "warning",
              title: this.$t("msg.alert"),
              text: this.$t("msg.alert_created_deposit"),
            },
            2000
          );
          return;
        } else {
          await this.$store
            .dispatch("postCreateAddress")
            .then((r) => {
              this.$store.dispatch("updateBluAccount").then(() => {
                setTimeout(() => {
                  this.checkWallet();
                  Swal.fire(
                    {
                      icon: "success",
                      title: this.$t("msg.success"),
                      text: this.$t("msg.success_create_wallet"),
                    },
                    2000
                  );
                });
              });
            })
            .catch((e) => {
              console.log(e);
              Swal.fire({
                icon: "error",
                title: this.$t("msg.error"),
                text: this.$t("msg.error_create_address"),
              });
            });
        }
      } else {



        let usdtAccount = this.accounts.filter(function (n, i) {
          return n.currency.symbol === "USDT";
        });

        this.buttonBlock = true;
        if (usdtAccount[0].address) {
          Swal.fire(
            {
              icon: "warning",
              title: this.$t("msg.alert"),
              text: this.$t("msg.alert_created_deposit"),
            },
            2000
          );
          return;
        } else {
          await this.$store
            .dispatch("postCreateWallet")
            .then((r) => {
              this.$store.dispatch("updateUsdtAccount").then(() => {
                setTimeout(() => {
                  this.checkWallet();
                  Swal.fire(
                    {
                      icon: "success",
                      title: this.$t("msg.success"),
                      text: this.$t("msg.success_create_wallet"),
                    },
                    2000
                  );
                });
              });
            })
            .catch((e) => {
              console.log(e);
              Swal.fire({
                icon: "error",
                title: this.$t("msg.error"),
                text: this.$t("msg.error_create_address"),
              });
            });
        }
      }
    },

    async getOtpStatus() {
      let resp = await this.$store.dispatch("getOtpStatus");
      this.authorized = resp.data;
      this.$emit("updateOptStatus");
    },

    switchMode() {
      this.$emit("switchMode");
    },
  },
  computed: {
    ...mapGetters(["accounts", "bluAccount", "usdtAccount"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/components/private/services/DepositMain.vue